/**
 * 信息披露
 *
 *  使用方法：
 *    存值  this.$store.commit('setInfoObj', Obj)
 *    取值  this.$store.state.info.infoObj
 */
export default {
  state: {
    // 信息对象值
    infoObj: {}
  },
  mutations: {
    setInfoObj(state, o) {
      state.infoObj = Object.assign(state.infoObj, o)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/info.js